import type { RoleProfile } from "utils/roles";
import {
  canSeeAi,
  canSeeBotsManagement,
  canSeeDataStorage,
  canSeeIntegrations,
  canSeeIntegrationsPlatform,
  canSeePartnerDirectory,
  canSeePartnerManagement,
  canSeeSecureExchange,
  canSeeSftpManagement,
  canSeeUserManagement,
} from "utils/roles";

export type NavKey =
  | "home"
  | "dataStorage"
  | "integrations"
  | "ai"
  | "partnerDirectory"
  | "secureExchange";

export type ManagementKey =
  | "userManagement"
  | "sftpManagement"
  | "partnerManagement"
  | "integrationsPlatform"
  | "botsManagement"
  | "splittingTools";

export interface NavItem<K> {
  key: K;
  label: string;
  path: string;
}

function join(basePath: string, path: string): string {
  if (!path || path === "/") return basePath || "/";
  return `${basePath}${path}`;
}

export function getSidebarNav(
  profile: RoleProfile,
  basePath = "",
): NavItem<NavKey>[] {
  const rows: NavItem<NavKey>[] = [
    { key: "home", label: "Home", path: join(basePath, "/") },
  ];
  if (canSeeDataStorage(profile))
    rows.push({
      key: "dataStorage",
      label: "Data Storage",
      path: join(basePath, "/data-storage"),
    });
  if (canSeeIntegrations(profile))
    rows.push({
      key: "integrations",
      label: "Integrations",
      path: join(basePath, "/integrations"),
    });
  if (canSeeAi(profile))
    rows.push({ key: "ai", label: "AI Reporting", path: join(basePath, "/chat") });
  if (canSeePartnerDirectory(profile))
    rows.push({
      key: "partnerDirectory",
      label: "Partner Directory",
      path: join(basePath, "/partners"),
    });
  if (canSeeSecureExchange(profile))
    rows.push({
      key: "secureExchange",
      label: "Secure Exchange",
      path: join(basePath, "/secure-exchange"),
    });
  return rows;
}

export function getManagementMenu(
  profile: RoleProfile,
  basePath = "",
): NavItem<ManagementKey>[] {
  const items: NavItem<ManagementKey>[] = [];
  if (canSeeUserManagement(profile))
    items.push({
      key: "userManagement",
      label: "User Management",
      path: join(basePath, "/user-management"),
    });
  if (canSeeSftpManagement(profile))
    items.push({
      key: "sftpManagement",
      label: "SFTP Management",
      path: join(basePath, "/sftp-management"),
    });
  if (canSeePartnerManagement(profile))
    items.push({
      key: "partnerManagement",
      label: "Partner Management",
      path: join(basePath, "/partner-management"),
    });
  if (canSeeIntegrationsPlatform(profile))
    items.push({
      key: "integrationsPlatform",
      label: "Integrations Platform",
      path: join(basePath, "/integrations-beta"),
    });
  if (canSeeBotsManagement(profile))
    items.push({
      key: "botsManagement",
      label: "Bots Management",
      path: join(basePath, "/bots-management"),
    });
  if (canSeeBotsManagement(profile))
    items.push({
      key: "splittingTools",
      label: "Splitting Tools",
      path: join(basePath, "/splitting-tools"),
    });
  return items;
}
